<template>
  <v-menu
    v-model="mainMenu"
    :close-on-content-click="false"
    offset-x 
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon   
        small             
        v-on="on"
      >
        <v-icon>more_vert</v-icon>
      </v-btn> 
    </template>

    <v-list dense>
      <v-menu 
        v-model="editMenu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-y
      >
        <template v-slot:activator="{ on: editMenu }">
          <v-list-item v-on="editMenu">
            <v-list-item-title> Edit </v-list-item-title>
          </v-list-item>
        </template>

        <v-card>
          <v-card-title> 
            Edit Skill Level
          </v-card-title>          
          <v-card-text>
            <v-progress-circular
              v-if="loading"
              :indeterminate="loading"
            />
            <v-menu          
              v-else     
              :close-on-content-click="false"
              :nudge-left="240"
              max-width="550px"
              open-on-hover
              left
            >
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-rating  
                    v-model="rating"
                    :length="(skill.levels || []).length"
                    hover
                    size="15"
                  /> 
                </div>
              </template>

              <v-card>
                <v-data-table
                  :headers="levelHeaders"
                  :items="skill.levels"
                  hide-default-footer
                  dense
                >
                  <template v-slot:item="props">
                    <tr :class="{active: props.item.level === rating}">
                      <td class="text-right">
                        {{ props.item.level }}
                      </td>
                      <td class="text-justify py-2">
                        {{ props.item.description }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-menu>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              :disabled="editProgressing"
              text
              @click="editMenu = false; mainMenu = false"
            >
              Close
            </v-btn>            
            <v-btn
              :loading="editProgressing"
              color="success"          
              @click="submitFormEdit"
            >
              Edit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
      <v-menu 
        v-model="deleteMenu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-y
      >
        <template v-slot:activator="{ on: deleteMenu }">
          <v-list-item v-on="deleteMenu">
            <v-list-item-title> Delete </v-list-item-title>
          </v-list-item>
        </template>

        <v-card>
          <v-card-text> Are you sure you want to delete this requirement? </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              :disabled="deleteProgressing"
              text
              @click="deleteMenu = false; mainMenu = false"
            >
              No
            </v-btn>
            <v-btn
              :loading="deleteProgressing"
              color="success"          
              @click="submitFormDelete"
            >
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-list>
  </v-menu>  
</template>

<script>
  export default {
    props: {
      skillLevel: {
        type: Object,
        required: true,
      },
      requirementId: {
        type: Number,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        mainMenu: null,
        editMenu: null,
        editProgressing: false,
        deleteMenu: null,
        deleteProgressing: false,
        skill: {},
        rating: null,
        levelHeaders: [
          {
            text: 'Level',
            value: 'level',
            sortable: false, 
          },
          { 
            text: 'Description', 
            align: 'left', 
            value: 'description',
            sortable: false, 
          },
        ],
      }
    },
    watch: {
      editMenu: function (value) {
        if (value) {
          this.editMenu = true
          this.rating = this.skillLevel.level

          this.loadSkill()
        }
      },
    },
    methods: {
      submitFormDelete () {
        this.deleteProgressing = true

        this.$api.positionJobRequirements().delete(this.requirementId)
          .then(response => {
            if (response.status >= 200 && response.status < 300) {
              this.$emit('deleted')
              this.$snack({ message: response.data.status })

              this.mainMenu = false
              this.deleteMenu = false
            }
          })
          .catch(error => {
            if (error.response.status >= 400 && error.response.status < 500) {
              this.$snack({ 
                color: 'error',
                message: error.response.data.status, 
              })
            }
          })
          .then(() => {
            this.deleteProgressing = false          
          })
      },
      submitFormEdit () {
        this.editProgressing = true

        this.$api.positionJobRequirements().update(this.requirementId, { skill_level_id: this.skill.levels[this.rating - 1].id })
          .then(response => {
            if (response.status >= 200 && response.status < 300) {
              this.$emit('updated')
              this.$snack({ message: response.data.status })

              this.mainMenu = false
              this.editMenu = false
            }
          })
          .catch(() => {})
          .then(() => {
            this.editProgressing = false
          })
      },
      loadSkill () {
        this.loading = true

        this.$api.skills().show(this.skillLevel.skill_id)
          .then((response) => {
            this.skill = response.data

            this.loading = false
          })
      },
    },
  }
</script>
